import { useState, useEffect } from 'react';
import { getRawData } from '../../services/front_api';
import SimpleGrid from './SimpleGrid';
import SSRMGrid from './SSRMGrid';
import { hasRole, rolesMap } from '../../services/auth';
import FilterChooser from '../filters/FilterChooser';
import LocalFiltersModal from '../filters/LocalFiltersModal';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

function gridChooser(view, app, query, queryId, debugUpdater, refreshKey) {
    switch (view) {
        case 'simple':
            return <SimpleGrid key={refreshKey} app={app} query={query} debugUpdater={debugUpdater} />;
        case 'ssrm':
            return <SSRMGrid key={refreshKey} app={app} query={query} queryId={queryId} debugUpdater={debugUpdater} />;
        default:
            return <div>Graphique non supporté</div>;
    }
}

const GridBuilder = ({ app, view, query, queryId, params }) => {
    // const [data, setData] = useState(null);
    // const [title, setTitle] = useState(null);
    const [debugresponse, setDebugresponse] = useState(null);
    const [debugurl, setDebugurl] = useState(null);
    const [debugbody, setDebugbody] = useState(null);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [refreshCount, setRefreshCount] = useState(0);

    // Valeurs statiques ou issues de paramètres / contrôles utilisateur
    const category = 'grid';

    useEffect(() => {
        try {
            setIsAdmin(hasRole(rolesMap.admin));
        } catch (e) {
            setIsAdmin(false);
        }
    }, []);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             // const { data, title } = await getChartsData(app, query, category);
    //             const [response, url, body] = await getRawData(app, query, category);
    //             setDebugresponse(response);
    //             setDebugurl(url);
    //             setDebugbody(body);
    //             const { data, title } = response;
    //             setData(data);
    //             setTitle(title);
    //         } catch (err) {
    //             setError(err);
    //         } finally {
    //             setLoading(false);
    //             setError(null);
    //         }
    //     };

    //     fetchData();
    // }, [app, query, category]);

    // if (loading) return <div>Chargement...</div>;
    // if (error) return <div>Erreur : {error.message}</div>;

    const debugUpdater = (response, url, body) => {
        setDebugresponse(response);
        setDebugurl(url);
        setDebugbody(body);
    };

    const tableTitle = typeof debugresponse?.title === 'string' ? debugresponse.title.trim() : '';

    const grid = gridChooser(view, app, query, queryId, debugUpdater, `${view}-${query}-${queryId || 'none'}-${refreshCount}`);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text ?? '');
            // feedback minimal : console (ou remplacer par un toast)
            console.log('copied');
        } catch (e) {
            console.error('copy failed', e);
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            {tableTitle && (
                <div style={{ paddingRight: 220, marginBottom: 10 }}>
                    <h3
                        style={{
                            margin: 0,
                            fontSize: 18,
                            lineHeight: 1.2,
                            color: 'var(--text-color)',
                        }}
                    >
                        {tableTitle}
                    </h3>
                </div>
            )}

            <div style={{ position: 'absolute', top: 8, right: 8, zIndex: 5, display: 'flex', gap: 8 }}>
                <button
                    onClick={() => setShowFiltersModal(true)}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.16)';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.background = 'var(--bg-menu)';
                        e.currentTarget.style.color = 'var(--accent-hover)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.background = 'var(--bg-content)';
                        e.currentTarget.style.color = 'var(--accent)';
                    }}
                    title="Filtres locaux"
                    aria-label="Filtres locaux"
                    style={{
                        width: 32,
                        height: 32,
                        padding: 0,
                        cursor: 'pointer',
                        borderRadius: 4,
                        border: '1px solid rgba(0,0,0,0.1)',
                        background: 'var(--bg-content)',
                        color: 'var(--accent)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'box-shadow 0.18s ease, transform 0.18s ease, background-color 0.18s ease',
                    }}
                >
                    <FilterAltOutlinedIcon fontSize="small" />
                </button>
                {isAdmin && (
                    <button
                        onClick={() => setShowModal(true)}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.16)';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.background = 'var(--bg-menu)';
                            e.currentTarget.style.color = 'var(--accent-hover)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.background = 'var(--bg-content)';
                            e.currentTarget.style.color = 'var(--accent)';
                        }}
                        title="Debug Query"
                        aria-label="Debug Query"
                        style={{
                            width: 32,
                            height: 32,
                            padding: 0,
                            cursor: 'pointer',
                            borderRadius: 4,
                            border: '1px solid rgba(0,0,0,0.1)',
                            background: 'var(--bg-content)',
                            color: 'var(--accent)',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'box-shadow 0.18s ease, transform 0.18s ease, background-color 0.18s ease',
                        }}
                    >
                        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="8" />
                            <path d="M12 8v5" />
                            <circle cx="12" cy="16.5" r="0.8" fill="currentColor" stroke="none" />
                        </svg>
                    </button>
                )}
            </div>

            {grid}

            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShowModal(false)}
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        style={{
                            width: '92%',
                            maxWidth: 1000,
                            maxHeight: '90vh',
                            background: '#fff',
                            borderRadius: 8,
                            padding: 0,
                            boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid #eee', background: '#fafafa' }}>
                            <div>
                                <strong style={{ fontSize: 16 }}>API Call details</strong>
                                <div style={{ fontSize: 12, color: '#666' }}>{'—'}</div>
                            </div>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                <button onClick={() => setShowModal(false)} style={{ padding: '6px 10px', cursor: 'pointer' }}>
                                    Fermer
                                </button>
                            </div>
                        </div>

                        <div style={{ padding: 16, display: 'grid', gridTemplateColumns: 'minmax(220px, 45%) 1fr', gap: 12, overflow: 'auto' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <strong>Request URL</strong>
                                    <button onClick={() => copyToClipboard(debugurl)} style={{ fontSize: 12, padding: '4px 8px' }}>Copier</button>
                                </div>
                                <pre style={{ margin: 0, padding: 10, background: '#f7f7f7', borderRadius: 4, overflow: 'auto', wordBreak: 'break-all', maxHeight: 220 }}>
                                    {debugurl || '—'}
                                </pre>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                    <strong>Request Body</strong>
                                    <button onClick={() => copyToClipboard(JSON.stringify(debugbody || {}, null, 2))} style={{ fontSize: 12, padding: '4px 8px' }}>Copier</button>
                                </div>
                                <pre style={{ margin: 0, padding: 10, background: '#f7f7f7', borderRadius: 4, overflow: 'auto', wordBreak: 'break-all', maxHeight: 220 }}>
                                    {debugbody ? JSON.stringify(debugbody, null, 2) : '—'}
                                </pre>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <strong>Response</strong>
                                    <button onClick={() => copyToClipboard(JSON.stringify(debugresponse || {}, null, 2))} style={{ fontSize: 12, padding: '4px 8px' }}>Copier</button>
                                </div>
                                <div style={{ flex: 1, overflow: 'auto', background: '#fff', borderRadius: 4, border: '1px solid #eee', padding: 10 }}>
                                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                        {debugresponse ? JSON.stringify(debugresponse, null, 2) : '—'}
                                    </pre>
                                </div>

                                <div style={{ marginTop: 8 }}>
                                    <strong>Notes</strong>
                                    <div style={{ fontSize: 13, color: '#555', marginTop: 6 }}>
                                        Les informations affichées sont destinées au débogage. Ne partagez pas les données sensibles.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showFiltersModal && (
                <LocalFiltersModal
                    description="Configurez les filtres locaux pour cette grille"
                    onClose={() => setShowFiltersModal(false)}
                    onValidate={() => {
                        setShowFiltersModal(false);
                        setRefreshCount((count) => count + 1);
                    }}
                >
                    <FilterChooser query={query} category={category} />
                </LocalFiltersModal>
            )}
        </div>
    );
};

export default GridBuilder;
